import {CertificateStatus} from './certificate-status.enum';
import {CertificateStructure} from './certificate.struct';
import {User} from './User';
import {StateService} from '../state.service';

export class Certificate implements CertificateStructure {

  public identifier: string;
  public description: string;
  public issuer: string;
  public expiryDate: Date;
  public status: CertificateStatus;
  public rejectionReason?: string;
  public thumbnail?: string;
  public owner: string;
  public pendingGrants?: string[];
  public grants?: string[];
  public filename?: string;
  public templateId?: number;

  constructor(certificate: CertificateStructure) {
    this.identifier = certificate.identifier;
    this.description = certificate.description;
    this.issuer = certificate.issuer;
    this.expiryDate = certificate.expiryDate;
    this.status = certificate.status || CertificateStatus.PENDING_APPROVAL;
    this.rejectionReason = certificate.rejectionReason;
    this.thumbnail = certificate.thumbnail;
    this.owner = certificate.owner;
    this.pendingGrants = certificate.pendingGrants || [];
    this.grants = certificate.grants || [];
    this.filename = certificate.filename;
    this.templateId = certificate.templateId;
  }

  public readableStatus(): string {
    switch (this.status) {
      case CertificateStatus.APPROVED:
        return "Approved";
      case CertificateStatus.PENDING_APPROVAL:
        return "Waiting for approval";
      case CertificateStatus.REJECTED:
        return "Rejected";
      case CertificateStatus.EXPIRED:
        return "Expired";
    }
  }

  public cssStatus(): string {
    switch (this.status) {
      case CertificateStatus.APPROVED:
        return "cert-approved";
      case CertificateStatus.PENDING_APPROVAL:
        return "cert-pending";
      case CertificateStatus.REJECTED:
        return "cert-rejected";
      case CertificateStatus.EXPIRED:
        return "cert-expired";
    }
  }

  public canView(user: User, stateService: StateService): boolean {
    let owner: User = stateService.getUserByUsername(this.owner);
    return this.owner === user.username || this.grants.indexOf(user.username) > -1 || user.isInstitution || owner.activeAccess.indexOf(user.username) > -1;
  }

  public isEligibleForApprovalBy(user: User): boolean {
    return user.isInstitution && this.status === CertificateStatus.PENDING_APPROVAL;
  }
}
